// WP-1.16 (OB-3, S-30 `/health`): the Data Health report query.
import { dataHealthReportSchema, type DataHealthReport } from '@pfos/shared';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from './api';

export const DATA_HEALTH_KEY = ['data-health'] as const;

export function useDataHealth(): UseQueryResult<DataHealthReport> {
  return useQuery({
    queryKey: DATA_HEALTH_KEY,
    queryFn: async () => dataHealthReportSchema.parse(await api.get('/api/v1/health')),
  });
}
